import { render, staticRenderFns } from "./AdRegistration.vue?vue&type=template&id=36818f20&scoped=true"
import script from "./AdRegistration.vue?vue&type=script&lang=ts"
export * from "./AdRegistration.vue?vue&type=script&lang=ts"
import style0 from "./AdRegistration.vue?vue&type=style&index=0&id=36818f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36818f20",
  null
  
)

export default component.exports